import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["content", "chevron"];
    static values = { open: { type: Boolean, default: true } };

    connect() {
        this.update();
    }

    toggle(event) {
        this.openValue = !this.openValue;
        this.update();
        // Émet `reveal:toggle` (avec l'état ouvert/fermé) pour laisser un
        // contenu masqué par défaut réagir à son affichage — ex. redessiner un
        // camembert Google Charts qui ne peut se dessiner que visible
        // (offsetWidth > 0). Cf. issue #482.
        this.dispatch("toggle", { detail: { open: this.openValue } });
    }

    update() {
        const hidden = !this.openValue;
        this.contentTargets.forEach((el) => (el.hidden = hidden));
        if (this.hasChevronTarget) {
            this.chevronTarget.classList.toggle("rotated", this.openValue);
        }
        this.element.classList.toggle("is-open", this.openValue);
    }
}